module.exports = __webpack_public_path__ + "static/media/vhi.89c8d6b2.jpg";